import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'score_popular', label: 'score_popular' },
  { id: 'score_trending', label: 'score_trending' },
  { id: 'num_buy', label: 'num_buy' },
  { id: 'num_sell', label: 'num_sell' },
  { id: 'zora_market_cap', label: 'zora_market_cap' },
  { id: 'zora_price_in_usdc', label: 'zora_price_in_usdc' },
  { id: 'zora_total_supply', label: 'zora_total_supply' },
  { id: 'zora_total_volume', label: 'zora_total_volume' },
  { id: 'zora_unique_holders', label: 'zora_unique_holders' },
  { id: 'zora_volume_24h', label: 'zora_volume_24h' },
  { id: 'num_follower', label: 'num_follower' },
  { id: 'zora_created_at', label: 'zora_created_at' },
  { id: 'zora_updated_at', label: 'zora_updated_at' },
  { id: 'last_interaction_timestamp', label: 'last_interaction_timestamp' },
  { id: 'null', label: 'None' },
];

const STRICT_FILTER_TYPE_OPTIONS = [
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'date', label: 'Date Range' },
  { id: 'publication_types', label: 'Publication Types' },
  { id: 'media_content_types', label: 'Media Content Types' },
  { id: 'domains', label: 'Domains' },
  { id: 'authors', label: 'Authors' },
  { id: 'author_followed_by', label: 'Author Followed By' },
  { id: 'market_info', label: 'Market Info' },
  { id: 'spam_moderation', label: 'Spam Moderation' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'is_null', label: 'Null / Not Null' },
  { id: 'boolean_filters', label: 'Boolean Filters' },
];

const BOOST_FILTER_TYPE_OPTIONS = [
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'date', label: 'Date Range' },
  { id: 'publication_types', label: 'Publication Types' },
  { id: 'media_content_types', label: 'Media Content Types' },
  { id: 'domains', label: 'Domains' },
  { id: 'authors', label: 'Authors' },
  { id: 'author_followed_by', label: 'Author Followed By' },
  { id: 'market_info', label: 'Market Info' },
  { id: 'spam_moderation', label: 'Spam Moderation' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'is_null', label: 'Null / Not Null' },
];

const ZoraCoinsQuery = () => {
  return (
    <QueryModes
      source="zora-coins"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={STRICT_FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={BOOST_FILTER_TYPE_OPTIONS}
    />
  );
};

export default ZoraCoinsQuery;
